import React, { useRef, useState } from "react";
// import { config } from "dotenv";
import ViewVideo from "./viewVideo";
import { ToastContainer } from "react-toastify";
import './Styles.css';
import { Tooltip } from "@material-ui/core";

export const RecordingsList = (props) => {
    // const [recordings, setRecordings] = useState({
    //     sessionName: '',
    //     sessionId: '',
    //     recordingList: []
    //   });
    // const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);
    const [open, setOpen] = useState(false);
    const videoUrl = useRef();
    const handleOpen = (url) => {
        setOpen(true);
        videoUrl.current = url;
    };
    const handleClose = () => {
        setOpen(false);
    };

    // useEffect(() => {
    //     getRecordingList();
    // }, []);

    // async function getRecordingList() {
    //     if (props && props.data._id) {
    //         setLoading(true);
    //         const sessionid = props.data.sessionId || props.data._id;
    //         const schedulId = md5(props.data._id);
    //         await getPastMeetings(sessionid, schedulId)
    //             .then((res) => {
    //                 // setRecordings(res.data);
    //                 if (res?.data) {
    //                     res.data.map((each) => {
    //                     //   duration.current = duration.current + handleDuration(new Date(each?.itemValue?.exitTime), new Date(each?.itemValue?.entryTime))
    //                       if (each?.itemValue?.recordingDetials?.length > 0) {
    //                         setRecordings({
    //                           ...recordings,
    //                           sessionName: res.data[0]?.sessionName,
    //                           sessionId: res.data[0]?.sessionId,
    //                           recordingList: [
    //                             ...recordings.recordingList,
    //                             ...each?.itemValue?.recordingDetials
    //                           ]
    //                         })
    //                       }
    //                     })
    //                   }
    //                 setLoading(false);
    //             })
    //             .catch((err) => {
    //                 console.log("errr--------", err);
    //                 if(API.isCancel(err)) {
    //                     console.log("API is canceled................");
    //                 } else {
    //                     setLoading(false);
    //                 }
    //             });
    //     }
    // }
    
    const handleCopy = (url) => {
        const textarea = document.createElement('textarea');
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }

    return (
        <div className="mtngColCntnr mtngcntrstyl">
            <div className="mtngRow rowSpaceBetween rowAlignCenter">
                <h2 className="ttlrcd">{props?.recordingData?.length > 0 ? `Total Recordings ( ${props?.recordingData?.length} )` : ""}</h2>
            </div>
            {props?.recordingData?.length > 0 ? (
                <div className="flexCol vidCntnrBox fullWidth">
                        <div className="flexWrap aCntnB fullWidth fullH pdngSM recordingslayout" >
                            {props?.recordingData?.map((eachRec, index) => (
                                    <div className="flexInline oneTwo pdngXS positionRelative " key={`key=${index + 1}`}>
                                        <img className="flexAutoCol" width={'100%'} height={'100%'} style={{objectFit:'contain'}} src={eachRec.thumbnail} alt="play" onClick={() => {
                                            handleOpen(
                                                eachRec.path
                                                );
                                                // }
                                            }
                                        }/>
                                        <Tooltip
                                            title={copied ? "Copied" : "Copy"}
                                            placement="top"
                                            onMouseLeave={() => setCopied(false)} // Reset on mouse leave
                                        >
                                            <img
                                                className="flexAutoCol plyBtn copyUrl"
                                                src="/images/icons/CopyLink.svg"
                                                alt="copy"
                                                onClick={() => handleCopy(eachRec.path)}
                                            />
                                        </Tooltip>
                                        {/* <video controls={false} style={{ width: "100%", borderRadius:'8px' }}>
                                            <source
                                                src={eachRec.path}
                                                type="video/mp4"
                                            />
                                            <style>
                                                {`
                                                video::part(play-button) {
                                                    width: 30px;
                                                    height: 30px;
                                                }
                                                `}
                                            </style>
                                        </video> */}
                                    </div>
                    ))}
                        </div>
                </div>
            ) : 
            // !loading ? 
            (
                <div className="noDataBlock">
                    <div className="noDataCircle">
                        <img src="/images/blue/outlined-recordings.png" alt="recordings icon" className="nodataImg invertGray" />
                    </div>
                    <h2 className="noDataTxt txtCenter">No Recordings Available</h2>
                </div>
            ) 
            // : (
            //     <Loader />
            // )
            }
            <ViewVideo open={open} handleClose={handleClose} url={videoUrl.current} />
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />
        </div>
    );
};
export default RecordingsList;
